import React from 'react';
import ConfirmationModal from '../../shared/confirmationModal';
import { Box, Typography } from '@mui/material';

const PreviewCreative = (props) => {
    const {
        open, onClosed, onConfirms,image_url
    } = props;
    return (
        <ConfirmationModal
            content={<Box className="min-w-300px flex-row-center min-height-200px">
                <img alt='Asset Preview' src={image_url || ''}/>
            </Box>}
            hideConfirmButton={true}
            open={open}
            primaryButtonText={''}
            title={<Typography className='queries-table-title'>Preview</Typography>}
            onClose={onClosed}
            onConfirm={onConfirms}
        />
    );
};

export default PreviewCreative;